import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const dailyReportImporterSelectors = importerSelectors(
  'dailyReport.importer',
);

export default dailyReportImporterSelectors;
